import gql from 'graphql-tag';

const CREATE_SHOPPER_NOTIFICATIONS = gql`  
    mutation createShopperNotification($input: ShopperNotificationInput) {
        createShopperNotification(input: $input) {
            internalCode
            idNotificacion
        }
    }
`;

export default CREATE_SHOPPER_NOTIFICATIONS;
